import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { ConstanteCliente } from '../models/constantecliente';
import { ComentarioIncidenciaComponent } from './comentario-incidencia/comentario-incidencia.component';
import { HistorialIncidenciasComponent } from './historial-incidencias/historial-incidencias.component';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDrawerContainer, MatDrawer } from '@angular/material/sidenav';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatTooltip } from '@angular/material/tooltip';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatDividerModule } from '@angular/material/divider';

@Component({
    selector: 'app-detalle-errores',
    standalone: true,
    templateUrl: './detalle-errores.component.html',
    styleUrls: ['./detalle-errores.component.css'],
    imports: [MatIconButton, MatIcon, MatDrawerContainer, MatFormField, MatLabel, MatInput, FormsModule, MatRadioGroup, MatRadioButton, MatTooltip, MatDrawer, MatSelect, MatOption, MatDividerModule]
})
export class DetalleErroresComponent implements OnInit {
  
  abierto = new ConstanteCliente();
 observacion = new ConstanteCliente();
 proceso = new ConstanteCliente();
 resultado = new ConstanteCliente();


  constructor(public dialogRef: MatDialogRef<DetalleErroresComponent>, @Inject(MAT_DIALOG_DATA) public dataUser: ConstanteCliente, public dialog:MatDialog,   )  { }

  ngOnInit() {
   this.abierto=this.dataUser;
   this.observacion=this.dataUser;
   this.proceso=this.dataUser;
   this.resultado=this.dataUser;
   
   
  }
 
  onCloseClick(): void {
    this.dialogRef.close();
  }
  
  agregaComentario() {
    this.dialog.open(ComentarioIncidenciaComponent, {
      height: '720px',
      width: '1200px',
      panelClass: 'custom-modalbox',
    });
}

guardaAsignado(){
  this.dialog.open(HistorialIncidenciasComponent, {
    //height: '720px',
    width: '1000px',
    panelClass: 'custom-modalbox',
    
});}
consultaImagenEvidencia(){
  this.dialog.open(HistorialIncidenciasComponent, {
    //height: '720px',
    width: '1000px',
    panelClass: 'custom-modalbox',
    
});}


verHistorial(){
  this.dialog.open(HistorialIncidenciasComponent, {
    //height: '720px',
    width: '1000px',
    panelClass: 'custom-modalbox',
    
});
}
}